/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum OverlayPositionTypeEnum {
    STATIC = 'STATIC',
    ABSOLUTE = 'ABSOLUTE',
    RELATIVE = 'RELATIVE',
    FIXED = 'FIXED',
    STICKY = 'STICKY',
}